import React from "react";
import { ReactSVG } from "react-svg";
import { Loader } from "../index";
import Functions from "./index.function";
const Button = ({
  text,
  bgColor = "bg-primary",
  weight,
  color = "text-white",
  className,
  onClick,
  textSize,
  isDisabled = false,
  icon,
  type,
  loading,
  loaderColor,
  classList,
}) => {
  const { TextWeight, width } = Functions();
  return (
    <button
      style={{
        fontSize: width > 640 ? textSize : textSize - 2,
        fontFamily: weight ? weight : TextWeight.Onest_regular,
      }}
      type={type}
      className={`py-2 flex justify-center min-h-[2.2rem] items-center gap-2 ${
        isDisabled
          ? "opacity-50"
          : "cursor-pointer hover:scale-105 hover:shadow-md transition-transform transform"
      } ${bgColor} ${color} ${
        weight ? weight : TextWeight.Onest_regular
      }  ${className}`}
      onClick={onClick}
      disabled={isDisabled || loading}
    >
      {loading ? (
        <Loader
          color={loaderColor ? loaderColor : "border-t-4"}
          width={"w-5"}
          height={"h-5"}
          className={"border-t-2"}
        />
      ) : (
        <>
          {icon && (
            <ReactSVG
              src={icon}
              beforeInjection={(svg) => {
                if (classList) {
                  classList.split(" ").forEach((cls) => svg.classList.add(cls));
                }
              }}
            />
          )}
          {text}
        </>
      )}
    </button>
  );
};

export default Button;
